<div>
  <h4>
    <SPAN style="color: #000000">MEDIGI PARTICIPATION AGREEMENT</SPAN>
    <SPAN style="color: #000000"> <br /><br /> </SPAN>
    <SPAN style="text-decoration: underline">PLATFORM TERMS OF USE</SPAN>
  </h4>
  <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
    <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
      By these Terms of Use (“Terms”), ___________________________________
      (“You,” Your”, “Pharmacy” or “Customer”), a licensed pharmacy, and Medigi,
      LLC, MedShorts, LLC, and 503B.Com (the “Companies” “We,” “Our,” or “Us”),
      the operator of Medigi.com, MedShorts.com, and 503B.com (the “Site(s)”)
      agree to the terms and conditions below regarding your use of the Site(s)
      and enjoyment of services offered on the Site(s) (the “Services”). Please
      read these Terms thoroughly to ensure a proper understanding of Your
      rights and responsibilities in connection with the Site(s).
    </SPAN>
  </P>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">1. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >Medigi.com, MedShorts.com, and 503B.com</SPAN
      >
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        You are being provided a limited, revocable, non-transferrable,
        non-sublicensable and non-exclusive right to the access and use of the
        Sites. By accessing and using the Site(s) and/or Services, You
        acknowledge and accept of these Terms and all other policies, guidelines
        and standards referenced herein. Please consult these Terms regularly as
        they may change from time-to-time. You must register as a Pharmacy and
        authorize the use and disclosure of the Pharmacy’s address, license(s),
        appropriate contact person(s), and any other necessary details
        (“Pharmacy Information”) to register the Pharmacy with The Companies for
        the purpose of allowing Us to provide the Services and as otherwise
        disclosed in our Privacy Policy before you can actively participate in
        the Services.
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">2. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">Service Description</SPAN>
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        We offer licensed pharmacies online access to procure pharmaceuticals
        directly from source manufacturers. Once your pharmacy is vetted,
        Authorized Users will have: secure webbased logins, marketplace
        catalogue visibility with real-time pricing, multi-manufacturer shopping
        cart, PO generation, email notifications (with frequency settings),
        customer support, reporting, and consolidated invoicing.
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">3. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >Transaction Fee; Payment Terms; Late Fees</SPAN
      >
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Each time You complete a purchase through one of the Sites, a
        transaction fee will be applied to the order. This fee covers the
        Services of the Site(s) including but not limited to payment of service
        fees for customer service and the technology required to host the
        Site(s). Depending on the payment terms selected, You may receive
        transaction fee discounts.
      </SPAN>
    </P>

    <p style="text-align: justify; margin-bottom: 10px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; font-style: italic"
        >Payment Terms</SPAN
      ><br />
    </p>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: bold; color: #000000">
        Select one of the Payment Terms below:
      </SPAN>
    </P>
    <ul>
      <li>
        7 Day Terms: ACH payment scheduled 7 days from the date the product is
        received (2% transaction fee).
      </li>
      <li>
        15 Day Terms: ACH payment scheduled 15 days from the date the product is
        received (3% transaction fee).
      </li>
      <li>
        30 Day Terms: ACH payment scheduled 30 days from the date the product is
        received (4% transaction fee).
      </li>
      <li>
        Point of Delivery: Credit card charged within 7 days upon the receipt of
        the product (3.5% transaction fee; with an additional 1.5% merchant
        processing fee applied to the order).
      </li>
    </ul>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        A request to change Payment Terms may be made after the first 12 months
        and each 12 months thereafter the Agreement Effective Date. Changes to
        Payment Terms will be agreed to by both Parties in writing.
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; font-style: italic"
        >Late Fees</SPAN
      ><br />
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Whenever a late payment is due to a cause attributable to Customer, all
        amounts not paid when due by a Customer shall accrue interest daily at
        the lesser of an annual rate of eighteen percent (18%) or the highest
        rate permissible by law on the unpaid overdue balance until paid in
        full.
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; font-style: italic"
        >Billing Agent</SPAN
      ><br />
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Regardless of the Sites from which you make a Purchase, you will
        generally be invoiced and billed by MedShorts.com or MedShorts, LLC
        (“MedShorts”), which serves as the Billing Agent for the Companies. All
        payments invoiced by MedShorts should be paid to MedShorts unless
        otherwise directed in any invoice.
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; font-style: italic"
        >Returns</SPAN
      ><br />
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        No returns are accepted unless stated otherwise. Manufacturer return
        policies, if available, differ from one another. Contact medigi directly
        to check if your purchase order is eligible for a return. Please note
        that any discounted short-dated medication bought through the MedShorts
        channel on medigi.com are NOT subject to return. All MedShorts sales are
        final.
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">4. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >Content For Informational Purposes Only
      </SPAN>
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        The information that You obtain or receive from the Companies, or their
        employees, contractors, partners, sponsors, advertisers, licensors or
        otherwise on the Site(s) or regarding Services is for informational and
        purchase facilitation purposes only. All medically related information
        is derived from independent health care professionals and organizations.
        Although some medically related content, text, data, graphics, images,
        suggestions, guidance, product details, product availability, vendor
        details, and other material (collectively, “Information”), including
        information provided in direct response to Your questions or postings,
        may be provided on the Site(s) and/or through the Services, such
        Information does not constitute and shall not be construed as a
        professional opinion, medical advice, or relied upon to diagnose or
        treat of any particular condition, but is provided solely to assist You
        with locating products made available by independent sellers on the
        Site(s).
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        No Information provided on the Sites and/or through the Services and in
        any other communications from or provided through The Companies shall be
        construed as a substitute for, nor does it replace, professional medical
        advice, diagnosis, or treatment. Do not use this Sites in the event of
        an emergency or to obtain emergency services; if You experience a
        medical emergency, call 911 immediately. Do not disregard, avoid or
        delay obtaining medical advice from a qualified health care professional
        because of information contained on the Sites and/or Services. Your use
        of the Information is solely at Your own risk. Nothing stated or posted
        the Sites and/or Services is intended to be the practice of medicine or
        the provision of medical care.
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">5. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >Absence of Buyer/Seller Relationship</SPAN
      >
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        No buyer/seller relationship is created between Us and You by You using
        Information provided by or through the use of the Sites and/or Services
        or through any other communications from Us including, but not limited
        to, links to other Sites and/or services. We do not monitor or review
        the content of other parties’ websites and/or services that are linked
        to or from this Our Sites. Opinions or information expressed on Our
        Sites or on linked websites are not necessarily shared or endorsed by Us
        and We are not the publisher of such opinions or material. Please be
        aware that We are not responsible for the privacy practices or content
        of other parties’ websites. We encourage You to be aware when You leave
        any of Our Site(s) and to read the privacy policies of other websites.
        You should evaluate the security and trustworthiness of any other
        website connected to or accessed through our Site(s) before disclosing
        any information to them. We will not accept any responsibility for any
        loss or damage resulting from your disclosure of information to third
        parties, regardless of whether you relied upon any information or links
        on our Site(s) to reach such third parties’ websites.
      </SPAN>
    </P>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Information provided on Our Site(s) is for Your convenience only. We
        take no responsibility for and make no representation, guaranty, or
        warranty, expressed or implied, about the vendors listed on the Site(s)
        or the fitness, suitability, qualifications, or quality of their
        products. Information contained on the Site(s) is publicly available
        information, and We cannot warrant or guarantee that the Information is
        accurate, complete or reliable. We cannot be held liable for the
        accuracy, reliability, or completeness of information provided by
        vendors, nor shall we be held accountable for the quality of products or
        services provided by any vendor listing its products on the Sites. It is
        Your responsibility to evaluate the quality and competence of any
        vendor, and to obtain any supplemental information regarding such vendor
        as You may deem necessary. By using the Site(s), You agree that We
        cannot and will not be held liable for any loss or damage suffered by
        You as a result of inaccurate, unreliable or incomplete Information by
        or about a vendor or a vendor’s products. We do not recommend any
        specific vendor or that you make a purchase from any vendor.
      </SPAN>
    </P>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        You should perform Your own investigation into the qualifications and
        credentials of a particular vendor before ordering products from such
        vendor. We are not responsible for cancelled or missed deliverables, nor
        shall we be responsible for any damages or injuries resulting from the
        misuse or unavailability of any products or services delivered or
        undelivered by any vendor.
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">6. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >User Representations and Acknowledgements</SPAN
      >
    </H4>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        By purchasing product through the site, you acknowledge, understand, and
        agree:
      </SPAN>
    </P>
    <ul style="list-style-type: disc">
      <LI>
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          Choosing a vendor is entirely Your own choice and responsibility.
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          Any and all prices and costs associated with products published to the
          Sites include a premium for the Services. You will pay the full costs
          published on the Site(s) to Us for any and all products you receive
          from any vendor through the Site(s).
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          As new features are added to the Site(s), We may charge a subscription
          fee for use or access to certain features. Subscription fees will be
          agreed to in writing before You are invoiced.
        </SPAN>
      </LI>
      <LI>
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          Vendors are listed on the Site(s) pursuant to a contractual agreement
          between each vendor and Us.
        </SPAN>
      </LI>
      <LI>
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          Vendors may pay a fee to Us to appear and have products appear on Our
          Site(s).
        </SPAN>
      </LI>
      <LI>
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          Products purchased are intended for Your own use and not for resale.
        </SPAN>
      </LI>
    </ul>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        If You choose to rely on any of the Information provided by the Site(s),
        You do so solely at Your own risk. We provide lists and/or profile
        previews of vendors. To aid in the discovery of vendors and enable the
        maximum choice and diversity of vendors who participate in the Services,
        lists and profile previews may also be based on other criteria
        (including, for example, vendor availability, past selections by and/or
        ratings of vendors by You or by other users, and past experience of
        users with vendors).
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        The Site(s) serve as an intermediary platform facilitating the purchase
        of products by users Purchasing Facility from contracted vendors. We do
        not manufacture, compound, possess, or produce products for sale on the
        Site(s) and We are not responsible for the products sold through the
        Site(s).
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">7. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">Website Accuracy</SPAN>
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        We make an effort to verify the accuracy of the Information, the
        timeliness and accuracy of any or all of the Information is not
        guaranteed. None of the parties who have been involved in the
        preparation or publication of the Site and/or Services can assure You
        that the Information contained herein is in every respect accurate or
        complete, and We are not responsible for any errors or omissions or for
        the results obtained from the use of such Information.
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        PROCEDURES/PRODUCTS/SERVICES: The procedures, products, services and
        devices discussed and/or advertised within the Site and/or Services may
        not be suitable for or applicable to You. We make no claims as to the
        effectiveness of any such procedures, products, services or devices. Any
        products and/or services represented on the Site and/or Services by
        advertisers, sponsors, and other Site and/or Services participants,
        either paid or unpaid, are presented solely for Your awareness.
      </SPAN>
    </P>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">8. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">User Accountability </SPAN>
    </H4>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        You are responsible for all costs and expenses of all Services provided
        to You by vendors profiled on the Site(s) who render services to You.
        You are responsible for Your use of the Site(s) and Services, including
        protecting your login name and password (“Credentials”). You remain
        responsible for any employee or agent to whom you provide your
        Credentials (whether such employee agent obtained them with or without
        Your permission or consent). You may use the Site(s) for lawful,
        non-commercial purposes only. Product returns are only permissible if
        the Vendor has a return policy, if the product is damaged in transit, or
        if the product received does not match your purchase order. You may not
        use contact information provided by Our users or vendors, or harvest
        such information for the purpose of sending, or to facilitate the
        sending, of unsolicited bulk communications such as SPAM. You may not
        allow others to use Your account to violate the terms of this section.
        We may terminate Your purchasing status or access to the Site(s)
        immediately and take other legal action if You or anyone using Your
        Credentials violates these provisions. You may not use the Site(s) or
        Services in any manner that could damage, disable, overburden, or impair
        Our servers or networks, or interfere with any other party's use and
        enjoyment of the Site(s) or Services. You may not attempt to gain
        unauthorized access to any of the Services, user accounts, computer
        systems, or networks through whether by hacking, password mining, or any
        other means. Without limiting any of the foregoing, You agree that You
        shall not:
      </SPAN>
    </P>
    <ul style="list-style-type: disc">
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          copy, share, modify, adapt, translate, or reverse engineer any portion
          of the Site(s), including any content, materials, or code;
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          remove, copy, distribute, republish, sell, or exploit any copyright,
          trademark or other proprietary rights notices contained in or on the
          Site(s) or in or on any content or other material obtained via the
          Site(s) for any commercial gain or purpose whatsoever;
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          use any robot, spider, search and retrieval application, or other
          automated device, process, or means to access, retrieve, or index any
          portion of the Site(s);
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          access, retrieve or index any portion of the Site(s) for purposes of
          constructing or populating a searchable database of reviews related to
          the health care industry or vendors;
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          reformat or frame any portion of the web pages that are part of the
          Site(s);
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          fraudulently misuse any of Our Site(s) by queuing or placing orders
          which you have no intention of keeping;
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          create user accounts by automated means or under false or fraudulent
          pretenses;
        </SPAN>
      </LI>
      <LI style="margin-bottom: 0px; margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          collect or store personal data about other users of Our Site(s); or
        </SPAN>
      </LI>
      <LI style="margin-left: 0px; text-indent: 0px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          use any means to conduct web scraping of any portion of the Site(s).
        </SPAN>
      </LI>
    </ul>
  </DIV>
  <DIV class="Part">
    <H4>
      <SPAN style="font-size: 12pt; color: #000000">9. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">Copyright Notice</SPAN>
    </H4>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        All material included on the Site(s), such as text, graphics, logos,
        images, photographs, audio clips, digital downloads, data compilations
        and software (“Content”) is Our property, exclusively owned by Us or Our
        corporate affiliates or third-party licensors and is protected by United
        States and international copyright laws. Modification or use of the
        Content not expressly in compliance with these Terms is prohibited and
        will constitute a violation of Our intellectual property rights. Content
        may not be copied, distributed, republished, uploaded, posted, or
        transmitted in any way without Our prior written consent, except that
        You may download, print, distribute, and use pages from the Sites and/or
        Services for your own informational, non- commercial purposes, or for
        general, non-commercial distribution.
      </SPAN>
    </P>
    <P style="text-align: left; line-height: 18px">
      <SPAN style="font-size: 12pt; color: #000000">10. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >Disclaimer of Warranties</SPAN
      >
    </P>
    <P style="text-align: left; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        This Site(s) and Services are provided by Us on an “as-is” and “as
        available” basis. We make no representations or warranties of any kind,
        express or implied, including, but not limited to, implied warranties of
        merchantability, fitness for a particular purpose, title, or
        non-infringement of third- party rights or intellectual property. Your
        use of this Site(s) and Services is at Your sole risk. We do not warrant
        that the Information in the Site(s) is accurate, reliable, up-to-date or
        correct, that this Site(s) will be available at any particular time or
        location, or for any period of time, or that any of the Sites is free of
        errors, defects, viruses or other harmful components. Content may
        include technical inaccuracies or typographical errors and We may make
        changes or improvements at any time. You assume the entire cost of all
        necessary servicing, repair, or correction in the event of any loss or
        damage You suffer arising from the use of this Site(s). We make no
        warranties that Your use of the Content will not infringe the rights of
        others and assume no liability or responsibility for errors or omissions
        in such content.
      </SPAN>
    </P>
    <P style="text-align: left; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Without limiting the generality of the foregoing, neither We nor any of
        Our principals, employees, independent contractors, agents, or
        representatives make any claims, representations, or warranties
        regarding the Site(s) and/or Services or the results, benefits,
        assurances, advantages, utility, safety, efficacy, success or popularity
        of, or results that may be attained, by using or accessing the Site(s).
      </SPAN>
    </P>
    <P style="text-align: left; line-height: 18px">
      <SPAN style="font-size: 12pt; color: #000000">11. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000"
        >General Limitation of Liability</SPAN
      >
    </P>
    <P style="text-align: left; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Neither Us, nor any of Our affiliates, directors, officers, and
        employees, nor any other party involved in creating, producing, or
        delivering the Site(s) or Services is liable for any direct, incidental,
        consequential, special, indirect, or punitive damages arising out of
        Your access to, or use of the Site(s) or Services or the failure of the
        Site(s) to operate or the failure of the Services to be available or
        produce any specific result. Except for Our indemnification obligations,
        in no event shall We be liable for any direct, indirect, special,
        punitive, incidental, exemplary or consequential, damages or any damages
        whatsoever, even if We have been previously advised of the possibility
        of such damages, whether in an action in contract, negligence, or any
        other theory, arising out of or in connection with the use, inability to
        use or performance of the information, services, products and materials
        available from any of our Site(s). We do not manufacture or compound
        products and shall have no liability whatsoever for any product
        liability, regarding of any negligence on our part. These limitations
        shall apply notwithstanding any failure of essential purpose of any
        limited remedy. Your acceptance of this limitation of liability is an
        essential term and We would not grant You access to the Site(s) without
        your agreement to this essential term or these Terms.
        <SPAN style="font-size: 12pt; font-weight: bold; color: #000000">
          If you are a California resident, you waive your rights with respect
          to California civil code section 1542, which says “a general release
          does not extend to claims which the creditor does not know or suspect
          to exist in his favor at the time of executing the release, which, if
          known by him must have materially affected his settlement with the
          debtor.”
        </SPAN>
        Because some states or jurisdictions do not allow the exclusion or the
        limitation of liability for consequential or incidental damages, in such
        states or jurisdictions, our liability shall be limited to the maximum
        extent permitted by law.
      </SPAN>
    </P>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; color: #000000">12. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">Termination</SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        Upon any violation of these Terms or Site policies (including any
        applicable privacy policy) by You or someone using Your Credentials, We
        may terminate and/or suspend Your registration and access to the Site(s)
        immediately, with or without notice. We may also cancel or suspend Your
        registration for any other reason, including inactivity for an extended
        period, upon thirty (30) days written notice. You shall have the right
        to terminate your purchasing status with Us upon thirty (30) days
        written notice. We shall not be liable to You or any third party for any
        termination of your access to the Site(s) or any of the Services. You
        agree not to attempt to use the Site(s) or Services after any such
        termination or suspension (provided, in the case of deactivation due
        exclusively to Your inactivity, You may re-register). Notwithstanding
        the foregoing, the provisions these Terms that apply to rights or
        obligations of a party which continue or arise upon or after the
        termination or expiration of this Agreement or which must survive
        termination to serve their essential purpose shall survive the
        termination or expiration of these Terms and Your termination of the
        right to access the Site(s).
      </SPAN>
    </P>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; color: #000000">13. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">Entire Agreement</SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        These Terms and any supplemental terms, policies, rules, and guidelines
        posted on the Site(s), including the privacy policy, constitute the
        entire agreement between You and Us and supersede all previous written
        or oral agreements with respect to the subject matter hereof. If any
        part of these Terms is held invalid or unenforceable, that portion shall
        be construed in a manner consistent with applicable law to reflect, as
        nearly as possible, the original intentions of these Terms and the
        remaining portions shall remain in full force and effect. Our failure to
        exercise or enforce any right or provision of these Terms shall not
        constitute a waiver of such right or provision.
      </SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 13px; line-height: 21px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        By accessing the Site(s), you shall be deemed to accept any applicable
        privacy policy posted on any such Site.
      </SPAN>
    </P>
    <P style="text-align: justify; line-height: 18px">
      <SPAN style="font-size: 12pt; color: #000000">14. </SPAN>
      <SPAN style="font-size: 12pt; color: #000000">Assignment</SPAN>
    </P>
    <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
      <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
        You may not assign this Agreement without Our written consent. We may
        assign this Agreement in connection with a transfer of all or
        substantially all of the assets of any of the Companies or any of our
        Affiliates, in connection with any corporate restructuring, and as we
        deem reasonably necessary to provide a continuity of the Services.
      </SPAN>
    </P>
    <DIV class="Sect">
      <H4>
        <SPAN style="font-size: 12pt; color: #000000">15. </SPAN>
        <SPAN style="font-size: 12pt; color: #000000">Eligibility</SPAN>
      </H4>
      <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          You must be 18 years of age or over, or the legal age to form a
          binding contract in your jurisdiction if that age is greater than 18
          years of age, to register with us or use the Site and/or Services and
          the Services. Only duly registered pharmacies in good standing and
          appropriately licensed with Your respective state board of Pharmacy,
          Enforcement Agency (DEA), and Food and Drug Administration (FDA) and
          applicable state laws, and healthcare providers and organizations that
          are duly licensed and authorized to procure and possess
          pharmaceuticals, including controlled substances, may utilize the
          Services and the Site. Products purchased through the Site are for
          Your own use and will not be re-sold. If you do not qualify under
          these terms, do not use the Site and/or Services. The right to
          purchase the Services is void where prohibited by applicable law, and
          the right to access the Site and/or Services is revoked in such
          jurisdictions. By using the Site and/or the Services, You represent
          and warrant that You have the right, authority, and capacity to enter
          into these Terms of Use and to abide by all of the terms and
          conditions set forth herein. The Site and/or Services is administered
          in the U.S. and intended for U.S. users; any use outside of the U.S.
          is at the users own risk and users are responsible for compliance with
          any local laws applicable to their use of the Services or the Site.
        </SPAN>
      </P>
    </DIV>
    <DIV class="Sect">
      <H4>
        <SPAN style="font-size: 12pt; color: #000000">16. </SPAN>
        <SPAN style="font-size: 12pt; color: #000000">Data Privacy</SPAN>
      </H4>
      <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          This Agreement establishes the Terms under which We and You can
          acquire and use data from the other party. Either party may be a
          provider of data to the other party, or a recipient of data from the
          other party. You acknowledge that all data on the Site(s), or supplied
          via email to You, or in any other format, from Us is proprietary and
          will not be released to any third party. Neither party will share,
          publish, or otherwise release any confidential findings or conclusions
          derived from analysis of data obtained from the data provider without
          prior approval from the data provider. In addition, both parties shall
          comply with all Federal and State laws and regulations governing the
          confidentiality of the Information described in these Term or obtained
          in connection with use of the Site and Services.
        </SPAN>
      </P>
    </DIV>
    <DIV class="Sect">
      <H4>
        <SPAN style="font-size: 12pt; color: #000000">17. </SPAN>
        <SPAN style="font-size: 12pt; color: #000000">Authorized User</SPAN>
      </H4>
      <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          For purposes of this Agreement, “Authorized Users” means persons who
          access the Sites and/or Services on your behalf and may include,
          without limitation, pharmacy directors or any other employees or
          representatives purchasing facilities. All Authorized Users shall be
          subject to these Terms. Purchasing Facilities, You, exclusively, are
          responsible for ensuring Authorized Users are aware these Terms and
          that Authorized Users comply with these terms at all times. Any act or
          omission by an Authorized User shall be deemed and act by You and any
          violation or breach of these Terms by an Authorized User shall be
          deemed a violation and breach by You. Without limiting the foregoing,
          You shall be responsible for ensuring that only Authorized Users with
          the authority to enter into binding agreements on your behalf place
          orders and/or submits offers on your behalf on the Site(s). Authorized
          Users should also be informed that invoices are generally delivered by
          and payable to MedShorts, regardless of the Site(s) from which any
          order is placed.
        </SPAN>
      </P>
    </DIV>
    <DIV class="Sect">
      <H4>
        <SPAN style="font-size: 12pt; color: #000000">18. </SPAN>
        <SPAN style="font-size: 12pt; color: #000000">Application</SPAN>
      </H4>
      <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          These Terms apply Your use of Medigi.com, MedShorts.com, 503B.com,
          regardless of your gateway to entry of the particular Site. You must
          also comply with any other Terms posted on any of Our Site(s). In the
          event of any conflict between these Terms and those posted on any
          other Site, these Terms shall control.
        </SPAN>
      </P>
      <P style="text-align: justify; margin-bottom: 18px; line-height: 18px">
        <SPAN style="font-size: 12pt; font-weight: normal; color: #000000">
          This Agreement shall become effective upon the execution by the
          Parties (“Agreement Effective Date”).
        </SPAN>
      </P>
    </DIV>

    <DIV class="Sect"
      ><H4
        ><SPAN style="font-size: 12pt; color: #000000"
          >AGREED AND ACCEPTED</SPAN
        ></H4
      ></DIV
    >
  </DIV>
</div>
